var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayTag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5199 13.6278L8.81777 18.0315C8.27298 18.4583 7.50118 18.4583 6.95639 18.0315L1.25426 13.6278C0.881987 13.3373 0.664062 12.8924 0.664062 12.4202V1.76955C0.664062 0.925129 1.34506 0.244141 2.18948 0.244141H13.5847C14.4291 0.244141 15.1101 0.925129 15.1101 1.76955V12.4202C15.1101 12.8924 14.8922 13.3373 14.5199 13.6278Z",
    fill: "#BFBFB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayTag);
export default __webpack_public_path__ + "static/media/gray_tag.0d67a69fc7e2c536c4bcf7e515e5e185.svg";
export { ForwardRef as ReactComponent };